export var BoxSizingProp;
(function (BoxSizingProp) {
    BoxSizingProp["border"] = "border-box";
    BoxSizingProp["content"] = "content-box";
})(BoxSizingProp || (BoxSizingProp = {}));
